import { z } from 'zod';
import { Calidad, MetodoIdentificacion, MetodoReparto } from './enums.js';
import { LaborCodigo } from './tarifas.js';
// §8 spec técnica: protocolo de sincronización app ↔ servidor.
const Uuid = z.string().uuid();
const Instante = z.string().datetime({ offset: true });
const Fecha = z.string().date();
export const MAX_ITEMS_LOTE = 500;
export const MAX_BYTES_LOTE = 1_000_000;
export const Evidencia = z
    .object({
    foto_sha256: z.string().regex(/^[a-f0-9]{64}$/).optional(),
    gps: z.tuple([z.number(), z.number(), z.number().nonnegative()]).optional(),
    metodo_id: MetodoIdentificacion.optional(),
})
    .strict();
export const ItemJornada = z.object({
    jornada_id: Uuid,
    fecha: Fecha,
    sociedad_id: Uuid,
    cuadrilla_id: Uuid,
    labor: LaborCodigo,
    ubicaciones: z.array(Uuid).min(1),
    tarifario_id: Uuid,
    abierta_en: Instante,
    cerrada_en: Instante.optional(),
});
export const ItemAsistencia = z.object({
    jornada_id: Uuid,
    persona_id: Uuid,
    ingreso_en: Instante,
    salida_en: Instante.optional(),
    metodo: MetodoIdentificacion,
    motivo_manual: z.string().min(3).optional(),
});
export const ItemEvento = z
    .object({
    evento_id: Uuid,
    jornada_id: Uuid,
    persona_id: Uuid.optional(),
    cuadrilla_id: Uuid.optional(),
    labor: LaborCodigo,
    ubicacion_id: Uuid.optional(),
    hilera: z.string().max(20).optional(),
    cantidad: z.number().nonnegative().optional(),
    unidad: z.string().optional(),
    horas: z.number().min(0).max(24).optional(),
    fecha_hecho: Instante,
    calidad: Calidad.default('aceptada'),
    castigo_unidades: z.number().nonnegative().default(0),
    evidencia: Evidencia.default({}),
})
    .refine((e) => e.persona_id || e.cuadrilla_id, { message: 'persona_id o cuadrilla_id requerido' })
    .refine((e) => e.cantidad !== undefined || e.horas !== undefined, { message: 'cantidad u horas requerido' });
export const ItemReparto = z
    .object({
    evento_id: Uuid,
    metodo: MetodoReparto,
    integrantes: z.array(Uuid).min(1),
    porcentajes: z.array(z.number().positive().max(100)).optional(),
})
    .refine((r) => r.metodo !== 'ponderador' || r.porcentajes?.length === r.integrantes.length, {
    message: 'ponderador requiere un porcentaje por integrante',
});
export const ItemAnulacion = z.object({
    evento_id: Uuid,
    anula_evento_id: Uuid,
    motivo: z.string().min(5),
});
export const ItemValidacionJornada = z.object({
    jornada_id: Uuid,
    validada_en: Instante,
    validada_por: Uuid,
});
export const ItemLote = z.discriminatedUnion('tipo', [
    z.object({ tipo: z.literal('jornada'), data: ItemJornada }),
    z.object({ tipo: z.literal('asistencia'), data: ItemAsistencia }),
    z.object({ tipo: z.literal('evento'), data: ItemEvento }),
    z.object({ tipo: z.literal('reparto'), data: ItemReparto }),
    z.object({ tipo: z.literal('anulacion'), data: ItemAnulacion }),
    z.object({ tipo: z.literal('validacion_jornada'), data: ItemValidacionJornada }),
]);
export const LoteSync = z.object({
    lote_id: Uuid,
    device_id: Uuid,
    maestro_version: z.number().int().nonnegative(),
    app_version: z.string(),
    enviado_en: Instante,
    items: z.array(ItemLote).min(1).max(MAX_ITEMS_LOTE),
});
export const EstadoItemLote = z.enum(['aceptado', 'duplicado', 'cuarentena', 'rechazado']);
export const RespuestaLote = z.object({
    lote_id: Uuid,
    recibidos: z.number().int(),
    resultados: z.array(z.object({ id: z.string(), estado: EstadoItemLote, codigo: z.string().optional() })),
});
//# sourceMappingURL=sync.js.map